<template>
  <div :class="className">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    yXs: Boolean,
    ySm: Boolean,
    y: Boolean,
    yLg: Boolean,
    yXl: Boolean,

    xXs: Boolean,
    xSm: Boolean,
    x: Boolean,
    xLg: Boolean,
    xXl: Boolean,

    lXs: Boolean,
    lSm: Boolean,
    l: Boolean,
    lLg: Boolean,
    lXl: Boolean,

    rXs: Boolean,
    rSm: Boolean,
    r: Boolean,
    rLg: Boolean,
    rXl: Boolean,

    tXs: Boolean,
    tSm: Boolean,
    t: Boolean,
    tLg: Boolean,
    tXl: Boolean,

    bXs: Boolean,
    bSm: Boolean,
    b: Boolean,
    bLg: Boolean,
    bXl: Boolean,

    divideY: Boolean,
    divideX: Boolean,
    divideL: Boolean,
    divideR: Boolean,
    divideT: Boolean,
    divideB: Boolean,
  },

  computed: {
    className() {
      return [
        this.yXs && 'py-2',
        this.ySm && 'py-4',
        this.y && 'py-8',
        this.yLg && 'py-12',
        this.yXl && 'py-16',

        this.xXs && 'px-2',
        this.xSm && 'px-4',
        this.x && 'px-8',
        this.xLg && 'px-12',
        this.xXl && 'px-16',

        this.lXs && 'pl-2',
        this.lSm && 'pl-4',
        this.l && 'pl-8',
        this.lLg && 'pl-12',
        this.lXl && 'pl-16',

        this.rXs && 'pr-2',
        this.rSm && 'pr-4',
        this.r && 'pr-8',
        this.rLg && 'pr-12',
        this.rXl && 'pr-16',

        this.tXs && 'pt-2',
        this.tSm && 'pt-4',
        this.t && 'pt-8',
        this.tLg && 'pt-12',
        this.tXl && 'pt-16',

        this.bXs && 'pb-2',
        this.bSm && 'pb-4',
        this.b && 'pb-8',
        this.bLg && 'pb-12',
        this.bXl && 'pb-16',

        this.divideY && 'border-y border-gray-200',
        this.divideX && 'border-x border-gray-200',
        this.divideL && 'border-l border-gray-200',
        this.divideR && 'border-r border-gray-200',
        this.divideT && 'border-t border-gray-200',
        this.divideB && 'border-b border-gray-200',
      ];
    },
  },
};
</script>
